<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">
        จับคู่ประเภทการลงเวลาจาก 3rd - Party
      </span>
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!dutyMatchingFormShow">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          ></v-text-field>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::duty_matching:create')"
            style="margin-top: 1px"
            color="primary"
            @click="handleAddDutyMatchingForm"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่มการจับคู่
          </v-btn>
        </div>
      </v-scroll-x-transition>
    </div>
    <!-- <v-toolbar flat color="blue-grey lighten-4">
      <span class="font-weight-medium"
        >จับคู่ประเภทการลงเวลาจาก 3rd - Party</span
      >
      <v-scroll-x-transition>
        <v-row align="center" v-show="!dutyMatchingFormShow">
          <v-spacer></v-spacer>
          <v-col md="3" lg="3" xl="2">
            <v-text-field
              v-model="search"
              label="ค้นหา"
              prepend-inner-icon="mdi-magnify"
              clearable
              flat
              solo
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-btn color="primary" @click="handleAddDutyMatchingForm">
            <v-icon small left>mdi-plus</v-icon>เพิ่มการจับคู่
          </v-btn>
        </v-row>
      </v-scroll-x-transition>
    </v-toolbar> -->
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="dutiesMatching"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.company_duty="{ item }">
        <span>{{ item.company_duty.title_th }}</span>
        <span class="grey--text">
          {{
            `( ประเภท: ${item.company_duty.duty_type.title_th}, รหัส: ${item.company_duty.duty_code} )`
          }}</span
        >
      </template>
    </v-data-table>
    <DutyMatchingForm
      :formShow="dutyMatchingFormShow"
      :formAction="dutyMatchingFormAction"
      :dutyMatching="dutyMatching"
      :dutyMatchingInit="dutyMatchingInit"
      @isDutyMatchingDataChange="handleDutyMatchingFormDataChange"
      @formActionCompleted="handleDutyMatchingFormActionCompleted"
      @onReset="handleDutyMatchingFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="dutyMatchingFormShow && dutyMatchingFormAction === 'add'"
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import DutyMatchingForm from '@/views/duty/DutyMatchingForm.vue'

export default {
  components: {
    DutyMatchingForm,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['3rd_party_duty_code'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      headers: [
        {
          text: 'รหัสประเภทการลงเวลาจาก 3rd - Party',
          align: 'start',
          value: '3rd_party_duty_code',
        },
        { text: 'ประเภทการลงเวลาที่ใช้งาน', value: 'company_duty' },
      ],
      dutyMatchingFormShow: false,
      dutyMatchingFormAction: '',
      dutyMatching: {},
      dutyMatchingInit: {},
      isDutyMatchingDataChange: false,
      timeout: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    dutiesMatching() {
      return this.$store.state.duty.dutiesMatching
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'จับคู่ประเภทการลงเวลาจาก 3rd - Party',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchDutiesMatching: 'duty/fetchDutiesMatching',
    }),
    classRowSelected(row) {
      if (
        this.dutyMatching.company_duty_matching_uuid ===
        row.company_duty_matching_uuid
      )
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::duty_matching:get')) {
        this.dialogForbidden = true
        return
      }

      if (
        this.dutyMatching.company_duty_matching_uuid ===
        row.company_duty_matching_uuid
      ) {
        this.dutyMatchingFormShow = false
        this.dutyMatchingFormAction = ''
        this.dutyMatching = {}
        this.dutyMatchingInit = {}
      } else {
        this.dutyMatchingFormShow = true
        this.dutyMatchingFormAction = 'edit'
        // this.dutyMatching = { ...row }
        // this.dutyMatchingInit = { ...row }
        this.dutyMatching = {
          ...row,
          company_duty_uuid: row.company_duty
            ? row.company_duty.company_duty_uuid
            : '',
        }
        this.dutyMatchingInit = {
          ...row,
          company_duty_uuid: row.company_duty
            ? row.company_duty.company_duty_uuid
            : '',
        }
      }
    },
    handleRowSelected(row) {
      if (this.isDutyMatchingDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddDutyMatchingForm() {
      this.dutyMatchingFormShow = true
      this.dutyMatchingFormAction = 'add'
      this.dutyMatching = {}
      this.dutyMatchingInit = {}
    },
    handleDutyMatchingFormDataChange(value) {
      this.isDutyMatchingDataChange = value
    },
    handleDutyMatchingFormReset(formAction) {
      if (formAction === 'edit')
        this.dutyMatching = { ...this.dutyMatchingInit }
    },
    handleDutyMatchingFormActionCompleted() {
      this.dutyMatching = {}
      this.dutyMatchingInit = {}
      this.dutyMatchingFormShow = false
      this.dutyMatchingFormAction = ''
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      this.fetchDutiesMatching(company_uuid)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.dutyMatchingFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isDutyMatchingDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
